module.exports = __webpack_public_path__ + "icons_01.e01ce687.svg";